import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const EmptyMessage = styled.p`
  margin-top: 4rem;
  text-align: center;
  color: #9a9a9a;
`;

export { Container, EmptyMessage };
